import React from "react";
import "../styles/AboutUs.css";
const AboutUs = () => {
  return (
    <section id="about" className="about-section">
      <h2>About Us</h2>
      <p>
        CodeNEST a Open Source Development Club of NSHM Knowledge Campus,
        Durgapur by Department of Computer Science and Engineering.
      </p>
      <p>
        CodeNEST is dedicated to fostering a collaborative environment for
        students to learn and contribute to open-source projects.
      </p>
    </section>
  );
};

export default AboutUs;
